"use client"

import { useState, useContext, useEffect } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import {
  TextField,
  Button,
  Container,
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Paper,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
} from "@mui/material"
import {
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  Badge as BadgeIcon,
  Business as BusinessIcon,
  Add as AddIcon,
  StorefrontOutlined as StorefrontIcon,
} from "@mui/icons-material"
import FormularioEntidadComponent from "./FormularioEntidadComponent.js"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"

const CrearProveedorComponent = () => {
  const { tipoEntidades, getTipoEntidad, postEntidad, condicionIva, getCondicionIva, isNavbarCollapsed } = useContext(ErpContext)

  const [descripcionEntidad, setDescripcionEntidad] = useState("")
  const [apellidoEntidad, setApellidoEntidad] = useState("")
  const [telefonoEntidad, setTelefonoEntidad] = useState("")
  const [emailEntidad, setEmailEntidad] = useState("")
  const [dniCuitCuilEntidad, setdniCuitCuilEntidad] = useState("")
  const [direccionEntidad, setDireccionEntidad] = useState("")
  const [localidadEntidad, setLocalidadEntidad] = useState("")
  const [provinciaEntidad, setProvinciaEntidad] = useState("")
  const [idCondicionIvaEntidad, setIdCondicionIvaEntidad] = useState("")

  const [showSuccess, setShowSuccess] = useState(false)
  const [errors, setErrors] = useState({})

  useEffect(() => {
    getTipoEntidad()
    getCondicionIva()
  }, [])

  const validateForm = () => {
    const newErrors = {}

    if (!descripcionEntidad.trim()) {
      newErrors.descripcion = "El nombre es requerido"
    }

    if (!dniCuitCuilEntidad.trim()) {
      newErrors.dniCuitCuil = "El DNI/CUIT/CUIL es requerido"
    }

    if (emailEntidad && !/\S+@\S+\.\S+/.test(emailEntidad)) {
      newErrors.email = "Email inválido"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const resetForm = () => {
    setDescripcionEntidad("")
    setApellidoEntidad("")
    setTelefonoEntidad("")
    setEmailEntidad("")
    setdniCuitCuilEntidad("")
    setDireccionEntidad("")
    setLocalidadEntidad("")
    setProvinciaEntidad("")
    setIdCondicionIvaEntidad("")
    setErrors({})
  }

  const handleEntidadSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      return
    }

    try {
      // Tipo de entidad fijo en 2 (Proveedor)
      await postEntidad(
        descripcionEntidad,
        apellidoEntidad,
        telefonoEntidad,
        emailEntidad,
        dniCuitCuilEntidad,
        direccionEntidad,
        localidadEntidad,
        provinciaEntidad,
        2, // idTipoEntidad fijo en 2 (Proveedor)
        idCondicionIvaEntidad,
      )

      resetForm()
      setShowSuccess(true)
      setTimeout(() => setShowSuccess(false), 3000)
      SucessModal()
    } catch (error) {
      ErrorModal()
    }
  }

  const ErrorModal = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "error",
      text: "Error al crear el proveedor",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  const SucessModal = () => {
    withReactContent(Swal).fire({
      position: "bottom-end",
      icon: "success",
      text: "Proveedor creado correctamente",
      showConfirmButton: false,
      timer: 3000,
      width: 300,
    })
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 2 }}>
      <Card elevation={2} sx={{ borderRadius: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <StorefrontIcon sx={{ color: "#5b5b5f", mr: 2, fontSize: 28 }} />
            <Typography variant="h5" sx={{ color: "#5b5b5f", fontWeight: 600 }}>
              Nuevo Proveedor
            </Typography>
          </Box>

          {showSuccess && (
            <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
              ¡Proveedor creado exitosamente!
            </Alert>
          )}

          <form onSubmit={handleEntidadSubmit}>
            <FormularioEntidadComponent
              descripcionEntidad={descripcionEntidad}
              setDescripcionEntidad={setDescripcionEntidad}
              apellidoEntidad={apellidoEntidad}
              setApellidoEntidad={setApellidoEntidad}
              dniCuitCuilEntidad={dniCuitCuilEntidad}
              setdniCuitCuilEntidad={setdniCuitCuilEntidad}
              telefonoEntidad={telefonoEntidad}
              setTelefonoEntidad={setTelefonoEntidad}
              emailEntidad={emailEntidad}
              setEmailEntidad={setEmailEntidad}
              direccionEntidad={direccionEntidad}
              setDireccionEntidad={setDireccionEntidad}
              localidadEntidad={localidadEntidad}
              setLocalidadEntidad={setLocalidadEntidad}
              provinciaEntidad={provinciaEntidad}
              setProvinciaEntidad={setProvinciaEntidad}
              idTipoEntidadEntidad={2}
              setIdTipoEntidadEntidad={() => {}}
              idCondicionIvaEntidad={idCondicionIvaEntidad}
              setIdCondicionIvaEntidad={setIdCondicionIvaEntidad}
              tipoEntidades={tipoEntidades}
              condicionIva={condicionIva}
              errors={errors}
              showCondicionIva={true}
              showTipoEntidad={false}
              compact={false}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
              <Button
                variant="outlined"
                onClick={resetForm}
                sx={{
                  borderColor: "#5b5b5f",
                  color: "#5b5b5f",
                  "&:hover": {
                    borderColor: "#5b5b5f",
                    backgroundColor: "rgba(91, 91, 95, 0.04)",
                  },
                }}
              >
                Limpiar
              </Button>
              <Button
                variant="contained"
                type="submit"
                startIcon={<StorefrontIcon />}
                sx={{
                  backgroundColor: "#5b5b5f",
                  "&:hover": {
                    backgroundColor: "#4a4a4e",
                  },
                  px: 4,
                }}
              >
                Crear Proveedor
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Container>
  )
}

export default CrearProveedorComponent
